const DEFAULT_UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export const parseUtmParams = (
  search: string,
  keys: readonly string[] = DEFAULT_UTM_KEYS
): Record<string, string> => {
  const params = new URLSearchParams(search);
  const utmData: Record<string, string> = {};

  keys.forEach((key) => {
    const value = params.get(key);
    if (value) {
      utmData[key] = value;
    }
  });

  return utmData;
};

export const convertUtmParamsForWebhooks = (
  utmParams: Record<string, string>
): Record<string, string | undefined> => {
  return {
    utmSource: utmParams.utm_source,
    utmCampaign: utmParams.utm_campaign,
    utmMedium: utmParams.utm_medium,
    utmContent: utmParams.utm_content,
    utmTerm: utmParams.utm_term,
  };
};
